import React from 'react';
import { createPortal } from 'react-dom';
import { TrendingUp, X } from 'lucide-react';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';
import { SURA_BLUE, SURA_BLUE2 } from './palette';

/* Modal reutilizable: muestra la tendencia anual de UN dato específico
   (una línea, un enlace, un equipo, una impresora...). `data` es un arreglo
   [{ name, fullMonth, total }] ya filtrado (solo meses con dato y no futuros). */
const TendenciaAnualModal = ({ isOpen, onClose, titulo, subtitulo, anio, data = [] }) => {
  if (!isOpen) return null;

  const hayDatos = data && data.length > 0;

  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl w-full max-w-2xl shadow-2xl overflow-hidden">
        <div
          className="px-6 py-5 flex justify-between items-center"
          style={{ background: `linear-gradient(135deg, ${SURA_BLUE} 0%, ${SURA_BLUE2} 100%)` }}
        >
          <div className="flex items-center gap-2 min-w-0">
            <TrendingUp size={18} className="text-white flex-shrink-0" />
            <div className="min-w-0">
              <h3 className="text-white font-bold m-0 truncate">{titulo || 'Tendencia Anual'}</h3>
              {subtitulo && <p className="text-white/60 text-xs m-0 mt-0.5 truncate">{subtitulo}</p>}
            </div>
          </div>
          <button onClick={onClose} className="text-white/70 hover:text-white flex-shrink-0">
            <X size={20} />
          </button>
        </div>

        <div className="p-6">
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs font-bold uppercase tracking-wider" style={{ color: SURA_BLUE }}>
              Gasto por mes
            </span>
            <span className="text-xs text-gray-400 font-medium">{anio}</span>
          </div>

          {hayDatos ? (
            <div className="h-72 w-full">
              <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={data} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
                  <defs>
                    <linearGradient id="gradTendenciaItem" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor={SURA_BLUE2} stopOpacity={0.3} />
                      <stop offset="95%" stopColor={SURA_BLUE2} stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
                  <XAxis dataKey="name" tick={{ fontSize: 11, fill: '#6b7280' }} axisLine={false} tickLine={false} />
                  <YAxis tick={{ fontSize: 11, fill: '#9ca3af' }} axisLine={false} tickLine={false} tickFormatter={v => `$${v}`} width={48} />
                  <Tooltip
                    contentStyle={{ borderRadius: '8px', border: '1px solid #e5e7eb', fontSize: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.08)' }}
                    formatter={(value) => [`$${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2 })}`, 'Gasto']}
                    labelStyle={{ fontWeight: 'bold', color: '#374151' }}
                  />
                  <Area type="monotone" dataKey="total" stroke={SURA_BLUE2} strokeWidth={2.5} fill="url(#gradTendenciaItem)" dot={{ r: 3, fill: SURA_BLUE2, strokeWidth: 0 }} activeDot={{ r: 5 }} />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          ) : (
            <p className="text-sm text-gray-400 italic text-center py-16">
              Este dato todavía no tiene meses con información cargada.
            </p>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default TendenciaAnualModal;
